import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, EditGroupDialogueHandler } from '../types';
import EditGroupDialogueContext from './EditGroupContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type EditGroupDialogueProps = {
  handleDialogue: DialogueHandler<EditGroupDialogueHandler>;
};

type FC = FunctionComponent<EditGroupDialogueProps>;

const EditGroupDialogue: FC = ({ handleDialogue }: EditGroupDialogueProps) => {
  const { showEditGroupErrorAlert, editGroupError } = useContext(EditGroupDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Edit.EditGroupErrorDialog' });

  return useMemo(
    () => (
      <div>
        {/* Edit Group Error */}
        <ConfirmationDialogue
          isVisible={showEditGroupErrorAlert}
          title={t('title')}
          status="error"
          subTitle={`${editGroupError}`}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showEditGroupErrorAlert, editGroupError],
  );
};

export default EditGroupDialogue;
